import React from 'react';
import GeneralWagonDetails from './GeneralWagonDetails';
// import AdditionalActionForMaintenance from './AdditionalActionForMaintenance';
import MaintenanceDetails from './MaintenanceDetails';
import TechnicalDetailsUnderFrame from './TechnicalDetailsUnderFrame';
import TankAndDischargement from './TankAndDischargement';
import OtherWagonDetails from './OtherWagonDetails';

export default function WagonDetailsTabContent(props) {
  const {
    wagonDetails,
    classes,
    expandedWagonGeneralDetails,
    // expandedAdditionalActionForMaintenance,
    expandedMaintenanceDetails,
    expandedTechnicalDetails,
    expandedTankAndDischargement,
    expandedOtherWagonDetails,
    handleChange,
  } = props;

  const handleExpandedChange = (section) => (event, newExpanded) => {
    handleChange(section, newExpanded);
  };

  return (
    <div>
      <GeneralWagonDetails
        wagonTechnicalDetails={wagonDetails.wagonTechnicalDetails}
        wagonStatus={wagonDetails.wagonStatus}
        classes={classes}
        expanded={expandedWagonGeneralDetails}
        handleChange={handleExpandedChange('generalWagonDetails')}
      />
      {/* <AdditionalActionForMaintenance
        classes={classes}
        expanded={expandedAdditionalActionForMaintenance}
        handleChange={handleExpandedChange('additionalActionForMaintenance')}
      /> */}
      <MaintenanceDetails
        wagonTechnicalDetails={wagonDetails.wagonTechnicalDetails}
        nextScheduledRevisionDate={wagonDetails.nextScheduledRevisionDate}
        classes={classes}
        expanded={expandedMaintenanceDetails}
        handleChange={handleExpandedChange('maintenanceDetails')}
      />
      <TechnicalDetailsUnderFrame
        wagonTechnicalDetails={wagonDetails.wagonTechnicalDetails}
        classes={classes}
        expanded={expandedTechnicalDetails}
        handleChange={handleExpandedChange('technicalDetails')}
      />
      <TankAndDischargement
        wagonTechnicalDetails={wagonDetails.wagonTechnicalDetails}
        classes={classes}
        expanded={expandedTankAndDischargement}
        handleChange={handleExpandedChange('tankAndDischargement')}
      />
      <OtherWagonDetails
        wagonTechnicalDetails={wagonDetails.wagonTechnicalDetails}
        classes={classes}
        expanded={expandedOtherWagonDetails}
        handleChange={handleExpandedChange('otherWagonDetails')}
      />
    </div>
  );
}
